"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChildSchema = void 0;
/**
 * Extracts the schema that applies to a property given a path.
 *
 * Expects the provided schema to have conditions resolved from the data in the form.
 */
const getChildSchema = (schema, path) => {
    let resolvedSchema = schema;
    let required = false;
    for (let i = 0; i < path.length; i++) {
        const part = path[i];
        const isLastPart = i + 1 === path.length;
        const subSchemas = [
            ...(resolvedSchema.allOf instanceof Array ? resolvedSchema.allOf : []),
            ...(resolvedSchema.anyOf instanceof Array ? resolvedSchema.anyOf : []),
            ...(resolvedSchema.oneOf instanceof Array ? resolvedSchema.oneOf : []),
        ];
        if (isLastPart) {
            required = !!resolvedSchema.required?.includes(String(part));
        }
        if (resolvedSchema.properties && part in resolvedSchema.properties) {
            resolvedSchema = resolvedSchema.properties[part];
            continue;
        }
        if (resolvedSchema.type === 'array' && Number.isInteger(Number(part))) {
            const index = Number(part);
            if (resolvedSchema.items instanceof Array && resolvedSchema.items[index]) {
                resolvedSchema = resolvedSchema.items[index];
            }
            else if (!(resolvedSchema.items instanceof Array)) {
                resolvedSchema = resolvedSchema.items;
            }
            else if (typeof resolvedSchema.additionalItems === 'object') {
                resolvedSchema = resolvedSchema.additionalItems;
            }
            else {
                throw new Error(`Cannot resolve schema for array index "${part}" (full path: "${path.join('.')}").`);
            }
            continue;
        }
        if (subSchemas.length > 0) {
            const subPath = path.slice(i);
            for (let j = 0; j < subSchemas.length; j++) {
                if (typeof subSchemas[j] !== 'object') {
                    continue;
                }
                const subSchema = subSchemas[j];
                try {
                    const resolvedChildSchema = (0, exports.getChildSchema)(subSchema, subPath);
                    if (resolvedChildSchema) {
                        return { schema: resolvedChildSchema.schema, required: resolvedChildSchema.required };
                    }
                }
                catch (error) {
                    // continue to next sub-schema, we may find the field there.
                }
            }
        }
        if (resolvedSchema.additionalProperties && typeof resolvedSchema.additionalProperties === 'object') {
            resolvedSchema = resolvedSchema.additionalProperties;
            continue;
        }
        throw new Error(`Cannot resolve schema for property "${part}" (full path: "${path.join('.')}").`);
    }
    if (typeof resolvedSchema !== 'object') {
        throw new Error(`Cannot resolve schema for path "${path.join('.')}".`);
    }
    return { schema: resolvedSchema, required };
};
exports.getChildSchema = getChildSchema;
//# sourceMappingURL=getChildSchema.js.map